
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import DivContainerBody from "../../../../../components/DivContainerBody";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../../../components/buttons/IconButtons";
import React from "react";
import {EmployeeFlowOrderForm} from "./EmployeeFlowOrderForm";
import {EmployeeFlowUpdateOrderApp} from "../../../Supplier/Funtionality/SupplierCreateUpdateFlows/EmployeeFlowUpdateOrderApp";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const EmployeeFlowUpdateOrder = () => {

    const {
        UpdateOrderHandler,
        order,
        emptyFields,
        handleChange
    } = EmployeeFlowUpdateOrderApp()

    return (
        <>
            <HeadTittle
                name={'update'}
                onBack={routes.suppliers.main}
            >
                <ButtonAction
                    id='btn_efu_update'
                    name='update'
                    className={'btn-icon-edit'}
                    Icon={EditIcon}
                    onClick={UpdateOrderHandler}
                />
            </HeadTittle>
            <DivContainerBody>
                <EmployeeFlowOrderForm
                    order={order}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                />
            </DivContainerBody>
        </>
    );
};
